/*eslint-disable*/
import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    MainHeadline,
    PageWrapper,
    PageFooter,
    Separator,
    Th,
} from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import { ModalTypes } from '../../types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { useNavigate } from 'react-router-dom'
import { clearAccommodations, deleteAccommodation, getAccommodations } from 'features/accommodation/accommodationSlice'
import { accommodationCategories, accommodationTypes } from './accommodationData'

export const Accommodation: React.FC = () => {
    const { accommodations, totalPages } = useSelector((store: RootState) => store.accomodation)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))

    useQueryPagination({ fetchFunctions: [getAccommodations], cleanUpFunctions: [clearAccommodations], params })

    const removeItem = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteAccommodation(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: accommodations.length < 2,
                },
                word: 'delete accommodation',
            }),
        )
    }


    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <MainHeadline>Accommodation</MainHeadline>
                    <Flex between gap='1rem' >
                        <Button orange onClick={() => navigate('users')}>
                            List Of Users
                        </Button>
                        <Button orange onClick={() => navigate('check-in')}>
                            Check in
                        </Button>
                        <Button orange onClick={() => navigate('add')}>
                            Add Accommodation
                        </Button>
                    </Flex>
                </Flex>
                {!accommodations.length ? (
                    <NoItems title='Accommodations' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='13.5%' noTooltip text='NAME' />
                            <Td w='12%' noTooltip text='ADDRESS' />
                            <Td w='10.5%' noTooltip text='CATEGORY' />
                            <Td w='9%' noTooltip text='TYPE' />
                            <Td w='9%' noTooltip text='ROOMS' />
                            <Td w='9%' noTooltip text='BEDS' />
                            <Td w='10.5%' noTooltip text='OCCUPIED BEDS' />
                            <Td w='10.5%' noTooltip text='START DATE' />
                            <Td w='10.5%' noTooltip text='END DATE' />
                            <Td w='5%' />
                        </Th>
                        {
                            accommodations.map((item) => {
                                return (
                                    <Tr view onClick={() => navigate(item.id.toString())} key={item.id}>
                                        <Td w='13.5%' text={item?.name} />
                                        <Td w='12%' text={item?.address} />
                                        <Td w='10.5%' text={accommodationCategories.find(c => c.value == item?.category).label} />
                                        <Td w='9%' text={accommodationTypes.find(a => a.value == item?.type).label} />
                                        <Td w='9%' text={item?.numberOfRooms} />
                                        <Td w='9%' text={item?.numberOfAvailableBeds} />
                                        <Td w='10.5%' text={item?.numberOfOccupiedBeds} />
                                        <Td w='10.5%' text={formatDateForDisplay(item?.startDate)} />
                                        <Td w='10.5%' text={formatDateForDisplay(item?.endDate)} />
                                        <Td options w='5%'>
                                            <Options item={item} title='Accommodation' handleRemove={removeItem} />
                                        </Td>
                                    </Tr>
                                )
                            })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
